import { Component, OnDestroy, OnInit } from '@angular/core';
import {SettingsService} from '../../../../configuration/settings.service';
import {MatDialog} from '@angular/material/dialog';
import {
  RouteStatusConfig,
  RouteStatusMapConfigComponent
} from '../route-status-map-config/route-status-map-config.component';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { LineDashArrayViewComponent } from '../../line-type-item/line-dash-array-view.component';
import { TrackStyles } from '../../../../configuration/model/TrackStyles';
import { Subscription } from 'rxjs';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';
import { ConfigurationService } from '../../../../configuration/configuration.service';

@Component({
  selector: 'app-route-status-mode-legend',
  templateUrl: './route-status-mode-legend.component.html',
  styleUrls: ['./route-status-mode-legend.component.scss'],
  imports: [MatIconButton, MatTooltip, MatIcon, LineDashArrayViewComponent],
})
export class RouteStatusModeLegendComponent implements OnInit, OnDestroy {

  defaultTrackStyles: TrackStyles;
  defaultStylesSubscription: Subscription;
  defaultLegendSettings: LayerTypeFilter;

  userTrackStyles: TrackStyles;
  userStylesSubscription: Subscription;
  userLegendSettings: LayerTypeFilter;

  constructor(
    public dialog: MatDialog,
    private settingsService: SettingsService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    this.defaultStylesSubscription = this.configurationService.trackStyles$.subscribe(trackStyles => {
      this.defaultTrackStyles = trackStyles;
      this.defaultLegendSettings = LayerTypeFilter.routeStatusLayerTypeFilter(trackStyles);
    });
    this.userStylesSubscription = this.configurationService.userTrackStyles$.subscribe(trackStyles => {
      this.userTrackStyles = trackStyles;
      this.userLegendSettings = LayerTypeFilter.routeStatusLayerTypeFilter(trackStyles);
    });
  }

  ngOnDestroy() {
    this.userStylesSubscription?.unsubscribe();
  }

  openConfiguration() {
    const defaultConfigCopy = JSON.parse(JSON.stringify(this.defaultLegendSettings));
    const userConfigCopy = JSON.parse(JSON.stringify(this.userLegendSettings));
    const data = {
      threshold: +this.settingsService.getStringValue(SettingsService.ROUTE_STATUS_THRESHOLD),
      defaultLegendSettings: defaultConfigCopy,
      legendSettings: userConfigCopy,
    } as RouteStatusConfig;

    const dialogRef = this.dialog.open(RouteStatusMapConfigComponent, {
      maxWidth: '80vw',
      maxHeight: '85vh',
      width: '500px',
      height: '510px',
      data: Object.assign({}, data),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result) {
        const settings = result as RouteStatusConfig;
        if (settings.threshold !== data.threshold) {
          this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_THRESHOLD, String(settings.threshold));
        }

        const serviced = settings.legendSettings.measurementUnits.find(i => i.number === 'Serviced');
        const defaultServiced = this.defaultLegendSettings.measurementUnits.find(i => i.number === 'Serviced');
        if (serviced && defaultServiced) {
          if (serviced.color === defaultServiced.color && serviced.dashArray === defaultServiced.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_SERVICED_STYLE, null);
          } else {
            this.userTrackStyles.routeStatusServiced.color = serviced.color;
            this.userTrackStyles.routeStatusServiced.dasharray = serviced.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_SERVICED_STYLE,
              JSON.stringify(this.userTrackStyles.routeStatusServiced)
            );
          }
        }

        const inProgress = settings.legendSettings.measurementUnits.find(i => i.number === 'In Progress');
        const defaultInProgress = this.defaultLegendSettings.measurementUnits.find(i => i.number === 'In Progress');
        if (inProgress && defaultInProgress) {
          if (inProgress.color === defaultInProgress.color && inProgress.dashArray === defaultInProgress.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_IN_PROGRESS_STYLE, null);
          } else {
            this.userTrackStyles.routeStatusInProgress.color = inProgress.color;
            this.userTrackStyles.routeStatusInProgress.dasharray = inProgress.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_IN_PROGRESS_STYLE,
              JSON.stringify(this.userTrackStyles.routeStatusInProgress)
            );
          }
        }

        const notServiced = settings.legendSettings.measurementUnits.find(i => i.number === 'Not Serviced');
        const defaultNotServiced = this.defaultLegendSettings.measurementUnits.find(i => i.number === 'Not Serviced');
        if (notServiced && defaultNotServiced) {
          if (notServiced.color === defaultNotServiced.color && notServiced.dashArray === defaultNotServiced.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_NOT_SERVICED_STYLE, null);
          } else {
            this.userTrackStyles.routeStatusNotServiced.color = notServiced.color;
            this.userTrackStyles.routeStatusNotServiced.dasharray = notServiced.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_NOT_SERVICED_STYLE,
              JSON.stringify(this.userTrackStyles.routeStatusNotServiced)
            );
          }
        }

        this.configurationService.refreshUserTrackStyles();
      }
    });
  }
}
